import { Link as RouterLink } from 'react-router-dom';

import { WEB_URL } from '../utils/constants';

interface LinkProps {
  label: string | JSX.Element;
  href: string;
  isExternal?: boolean;
  target?: string;
  className?: string;
}

const Link = (props: LinkProps) => {
  if (props.isExternal) {
    return (
      <a
        style={{ opacity: 1, textDecoration: 'none' }}
        target={props.target}
        className={['hover-blue5 blue4', props.className ? props.className : ''].join(' ')}
        href={`${WEB_URL}${props.href}`}
      >
        {props.label}
      </a>
    );
  }

  return (
    <RouterLink
      style={{ opacity: 1, textDecoration: 'none' }}
      className={['hover-blue5 blue4', props.className ? props.className : ''].join(' ')}
      to={props.href}
    >
      {props.label}
    </RouterLink>
  );
};

export default Link;
